import {api} from "@/app/services/api.service";

const state = {
    copyrightAmendment:null,
    copyrightAmendmentError:null,
    copyrightAmendmentTask:null,
    copyrightAmendmentTaskError:null,
    copyrightAmendmentTaskCount:null,
    copyrightAmendmentTaskCountError:null,
    copyrightAmendmentTaskUpdateStatus:null,
    copyrightAmendmentTaskUpdateStatusError:null,
    copyrightAmendmentStatistics:null,
    copyrightAmendmentStatisticsError:null,
    copyrightAmendments:null,
    copyrightAmendmentsError:null,
    copyrightAmendmentTaskMessages:null,
    copyrightAmendmentTaskMessagesError:null,
    copyrightAmendmentEscalation:null,
    copyrightAmendmentEscalationError:null,
    copyrightAmendmentEscalations:null,
    copyrightAmendmentEscalationsError:null,
    copyrightAmendmentRegistry:null,
    copyrightAmendmentRegistryError:null,
};

const getters = {
    getCopyrightAmendmentTask: (state) => state.copyrightAmendmentTask,
    getCopyrightAmendmentTaskError: (state) => state.copyrightAmendmentTaskError,
    getCopyrightAmendmentTaskCount: (state) => state.copyrightAmendmentTaskCount,
    getCopyrightAmendmentTaskCountError: (state) => state.copyrightAmendmentTaskCountError,
    getCopyrightAmendmentTaskUpdateStatus: (state) => state.copyrightAmendmentTaskUpdateStatus,
    getCopyrightAmendmentTaskUpdateStatusError: (state) => state.copyrightAmendmentTaskUpdateStatusError,
    getCopyrightAmendmentStatistics: (state) => state.copyrightAmendmentStatistics,
    getCopyrightAmendmentStatisticsError: (state) => state.copyrightAmendmentStatisticsError,
    getCopyrightAmendments: (state) => state.copyrightAmendments,
    getCopyrightAmendmentsError: (state) => state.copyrightAmendmentsError,
    getCopyrightAmendmentTaskMessages: (state) => state.copyrightAmendmentTaskMessages,
    getCopyrightAmendmentTaskMessagesError: (state) => state.copyrightAmendmentTaskMessagesError,
    getCopyrightAmendment: (state) => state.copyrightAmendment,
    getCopyrightAmendmentError: (state) => state.copyrightAmendmentError,
    getCopyrightAmendmentEscalation: (state) => state.copyrightAmendmentEscalation,
    getCopyrightAmendmentEscalationError: (state) => state.copyrightAmendmentEscalationError,
    getCopyrightAmendmentEscalations: (state) => state.copyrightAmendmentEscalations,
    getCopyrightAmendmentEscalationsError: (state) => state.copyrightAmendmentEscalationsError,
    getCopyrightAmendmentRegistry: (state) => state.copyrightAmendmentRegistry,
    getCopyrightAmendmentRegistryError: (state) => state.copyrightAmendmentRegistryError,
};

const actions = {
    async fetchCopyrightAmendmentTask({commit}){
        await api().get("copy-right/api/v1/transactions/task/queue").
        then(async response => {
            if (response.data && response.data.data && response.data.data.applicationId) {
                const task = response.data.data;
                await api().get("copy-right/api/v1/transactions/id/" + task.applicationId).
                then(detailsResponse => {
                    const applicationDetails = detailsResponse.data && detailsResponse.data.data ? detailsResponse.data.data : null;
                    const combined = {
                        ...response.data,
                        data: {
                            ...applicationDetails,
                            id: task.id,
                            applicationId: task.applicationId,
                            assignedTo: task.assignedTo,
                            status: task.status,
                            createdAt: task.createdAt,
                            updatedAt: task.updatedAt
                        }
                    };
                    commit('setCopyrightAmendmentTask', { data: combined });
                }).catch(error => {
                    commit("setCopyrightAmendmentTaskError", error.response);
                });
            } else {
                commit('setCopyrightAmendmentTask', response);
            }
        }).catch(error => {
            commit("setCopyrightAmendmentTaskError", error.response)
        });
    },
    async fetchCopyrightAmendmentTaskCount({commit}){
        await api().get("copy-right/api/v1/applications/queue/count").
        then(response => {
            commit('setCopyrightAmendmentTaskCount', response.data);
        }).catch(error => {
            commit("setCopyrightAmendmentTaskCountError", error.response)
        });
    },
    async updateCopyrightAmendmentTaskStatus({commit}, data){
        const payload = {
            applicationId: data.applicationId || data.copyrightAmendmentId || "",
            taskId: data.taskId || data.queueId || "",
            status: data.status || "APPROVED",
            message: data.message || data.reason || "Application updated.",
            officerNotes: data.officerNotes || data.message || data.reason || ""
        };
        await api().put("copy-right/api/v1/amendments/task/action", payload).
        then(response => {
            commit('setCopyrightAmendmentTaskUpdateStatus', response.data);
        }).catch(error => {
            commit("setCopyrightAmendmentTaskUpdateStatusError", error.response)
        });
    },
    async fetchCopyrightAmendmentStatistics({commit}){
        await api().get("copy-right/api/v1/amendments/stats").
        then(response => {
            commit('setCopyrightAmendmentStatistics', response.data);
        }).catch(error => {
            commit("setCopyrightAmendmentStatisticsError", error.response)
        });
    },
    async fetchAllCopyrightAmendmentApplications({commit}, data) {
      let path="copy-right/api/v1/transactions?status="+data.status+"&page="+data.page+"&pageSize="+data.limit;

      if(data.startRegistrationDate){
        path+="&dateOfEffectStart="+data.startRegistrationDate
      } if(data.endRegistrationDate){
        path+="&dateOfEffectEnd="+data.endRegistrationDate
      }
        await api()
            .get(path)
            .then(response => {
                commit('setCopyrightAmendments', response.data);
            }).catch(error => {
                commit("setCopyrightAmendmentsError", error.response)
            });
    },
    async fetchCopyrightAmendmentTaskMessages({commit}, data){
        let taskId = "";
        let path = "copy-right/api/v1/applications/task/messages/";
        if (typeof data === "object" && data !== null) {
            taskId = data.id || data.taskId || "";
            path += taskId;
            let params = [];
            if (data.page !== undefined) params.push("page=" + data.page);
            if (data.limit !== undefined) params.push("limit=" + data.limit);
            if (data.status !== undefined) params.push("status=" + data.status);
            if (params.length > 0) {
                path += "?" + params.join("&");
            }
        } else {
            taskId = data;
            path += taskId;
        }
        await api().get(path).
        then(response => {
            commit('setCopyrightAmendmentTaskMessages', response.data);
        }).catch(error => {
            commit("setCopyrightAmendmentTaskMessagesError", error.response)
        });
    },
    async fetchCopyrightAmendmentByTrackingNumber({commit}, trackingNumber) {
        await api()
            .get("copy-right/api/v1/amendments/find/" + trackingNumber)
            .then((response) => {
                commit("setCopyrightAmendment", response.data);
            })
            .catch((error) => {
                commit("setCopyrightAmendmentError", error.response);
            });
    },
    async fetchCopyrightAmendmentByReservationNumber({commit}, reservationNumber) {
        await api()
            .get("copy-right/api/v1/applications/by-reservation-no/" + reservationNumber)
            .then((response) => {
                commit("setCopyrightAmendment", response.data);
            })
            .catch((error) => {
                commit("setCopyrightAmendmentError", error.response);
            });
    },
    async escalateCopyrightAmendmentTask({commit, state}, data) {
        commit("setCopyrightAmendmentEscalation", null);
        let appId = "";
        if (state.copyrightAmendmentTask && state.copyrightAmendmentTask.data && state.copyrightAmendmentTask.data.applicationId) {
            appId = state.copyrightAmendmentTask.data.applicationId;
        } else if (state.copyrightAmendment && state.copyrightAmendment.id) {
            appId = state.copyrightAmendment.id;
        } else if (state.copyrightAmendment && state.copyrightAmendment.data && state.copyrightAmendment.data.id) {
            appId = state.copyrightAmendment.data.id;
        }
        const payload = {
            applicationId: data.applicationId || appId || "",
            taskId: data.taskId || data.queueId || "",
            userId: data.userId || data.registrarId || "",
            message: data.message || data.comment || ""
        };
        await api()
            .post("copy-right/api/v1/applications/task/escalate", payload)
            .then((response) => {
                commit("setCopyrightAmendmentEscalation", response.data);
            })
            .catch((error) => {
                commit("setCopyrightAmendmentEscalationError", error.response);
            });
    },
    async fetchCopyrightAmendmentEscalations({commit}, data){
        await api().get("copy-right/api/v1/applications/task/escalations?page="+data.page+"&perPage="+data.limit).
        then(response => {
            commit('setCopyrightAmendmentEscalations', response.data);
        }).catch(error => {
            commit("setCopyrightAmendmentEscalationsError", error.response)
        });
    },
    async fetchCopyrightAmendmentRegistry({commit}, data) {
        let path = "copy-right/api/v1/copyright-amendment/registry?page=" + data.page + "&pageSize=" + data.limit;
        if (data.search) {
            path += "&search=" + data.search;
        }
        if (data.certificateNumber) {
            path += "&certificateNumber=" + data.certificateNumber;
        }
        if (data.title) {
            path += "&title=" + data.title;
        }
        if (data.startDate) {
            path += "&startDate=" + data.startDate;
        }
        if (data.endDate) {
            path += "&endDate=" + data.endDate;
        }
        await api()
            .get(path)
            .then(response => {
                commit("setCopyrightAmendmentRegistry", response.data);
            })
            .catch(error => {
                commit("setCopyrightAmendmentRegistryError", error.response);
            });
    },
};

const mutations = {
    setCopyrightAmendmentTask:(state, response) =>{
        state.copyrightAmendmentTask = response.data
    },
    setCopyrightAmendmentTaskError:(state, response) =>{
        state.copyrightAmendmentTaskError = response.data
    },
    setCopyrightAmendmentTaskCount:(state, response) =>{
        state.copyrightAmendmentTaskCount = response && response.data ? response.data : response
    },
    setCopyrightAmendmentTaskCountError:(state, response) =>{
        state.copyrightAmendmentTaskCountError = response.data
    },
    setCopyrightAmendmentTaskUpdateStatus:(state, response) =>{
        state.copyrightAmendmentTaskUpdateStatus = response
    },
    setCopyrightAmendmentTaskUpdateStatusError:(state, response) =>{
        state.copyrightAmendmentTaskUpdateStatusError = response.data
    },
    setCopyrightAmendmentStatistics:(state, response) =>{
        const stats = response && response.data ? response.data : response;
        if (stats) {
            const approved = stats.approved || 0;
            const assigned = stats.assigned || 0;
            const pending = stats.pending || 0;
            const rejected = stats.rejected || 0;
            const draft = stats.draft || 0;
            const escalated = stats.escalated || stats.myAssigned || 0;
            const queried = stats.queried || 0;
            const total = stats.total || (approved + assigned + pending + rejected + draft + escalated + queried);

            state.copyrightAmendmentStatistics = {
                draft,
                pending,
                assigned,
                escalated,
                queried,
                approved,
                rejected,
                total
            };
        } else {
            state.copyrightAmendmentStatistics = null;
        }
    },
    setCopyrightAmendmentStatisticsError:(state, response) =>{
        state.copyrightAmendmentStatisticsError = response.data
    },
    setCopyrightAmendments:(state, response) => {
        state.copyrightAmendments = response
    },
    setCopyrightAmendmentsError:(state, error) => {
        state.copyrightAmendmentsError = error
    },
    setCopyrightAmendmentTaskMessages: (state, response) => {
        let content = [];
        if (response && response.data) {
            if (Array.isArray(response.data.content)) {
                content = response.data.content;
            } else if (Array.isArray(response.data)) {
                content = response.data;
            }
        } else if (response && Array.isArray(response.content)) {
            content = response.content;
        } else if (Array.isArray(response)) {
            content = response;
        }

        state.copyrightAmendmentTaskMessages = content.map(msg => {
            if (msg.messageData) {
                return msg;
            }
            return {
                ...msg,
                messageData: {
                    sender: [msg.senderFirstName, msg.senderLastName].filter(Boolean).join(' ') || msg.senderId || 'System',
                    senderRole: msg.senderAccountType || '',
                    comment: msg.message || '',
                    createdAt: msg.createdAt
                }
            };
        });
    },
    setCopyrightAmendmentTaskMessagesError: (state, response) =>{
        state.copyrightAmendmentTaskMessagesErrors = response.data;
    },
    setCopyrightAmendment: (state, response) =>{
        state.copyrightAmendment = response.data;
    },
    setCopyrightAmendmentError: (state, response) =>{
        state.copyrightAmendmentError = response.data;
    },
    setCopyrightAmendmentEscalation: (state, response) =>{
        state.copyrightAmendmentEscalation = response;
    },
    setCopyrightAmendmentEscalationError: (state, response) =>{
        state.copyrightAmendmentEscalationError = response.data;
    },
    setCopyrightAmendmentEscalations: (state, response) => {
        state.copyrightAmendmentEscalations = response;
    },
    setCopyrightAmendmentEscalationsError: (state, response) => {
        state.copyrightAmendmentEscalationsError = response.data;
    },
    setCopyrightAmendmentRegistry: (state, response) => {
        state.copyrightAmendmentRegistry = response;
    },
    setCopyrightAmendmentRegistryError: (state, response) => {
        state.copyrightAmendmentRegistryError = response.data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
